
// @ts-nocheck
import {
  UPDATE_MODEL_EVENT,
  CHANGE_EVENT,
  BLUR_EVENT
} from '@/components/utils/constants'
import { label, useLabel } from '@/components/utils/label'
import {
  useValidate,
  validate,
  getValidationProps
} from '@/components/utils/validate'
import { defineComponent } from 'vue'
import ElSelect, { Option as ElOption } from '@/components/select'
import { IComboBoxProps } from './combobox.type'
import useComboBox from './useComboBox'
import ComboboxProps from './combobox.prop'

export default defineComponent({
  name: 'MsComboBox',

  inheritAttrs: false,

  components: {
    ElSelect,
    ElOption
  },

  mixins: [label, validate],

  emits: [UPDATE_MODEL_EVENT, CHANGE_EVENT, BLUR_EVENT],

  props: {
    ...ComboboxProps
  },

  setup (props: IComboBoxProps & Record<string, any>, context) {
    const { labelCls, labelStyles } = useLabel(props)
    const validationObj = useValidate(props, context)
    const validationProps = getValidationProps(validationObj)
    const comboBox = useComboBox(props, context)

    return {
      labelCls,
      labelStyles,
      ...validationProps,
      ...comboBox
    }
  },

  data () {
    return {
      selectedValue: null
    }
  },

  computed: {
    cssCls () {
      const me = this

      return {
        'ms-combo-box': true,
        'has-error': me.hasError,
        ...me.labelCls,
        [me.validateCls]: true
      }
    },

    labelStyle () {
      return {
        ...this.labelStyles
      }
    },

    scopedSlots () {
      const scopedSlots = { ...this.$slots }

      if (scopedSlots.default) {
        delete scopedSlots.default
      }
      return scopedSlots
    }
  }
})
